import { Outlet, useNavigate, Navigate } from "react-router-dom";
import { Suspense } from "react";
import { useMasterAuth } from "@/context/MasterAuthContext";
import { useBranding } from "@/context/BrandingContext";
import SessionUnavailable from "../components/SessionUnavailable";
import MasterBrand from "./components/MasterBrand";
import MasterNavigation from "./components/MasterNavigation";
import MasterUserMenu from "./components/MasterUserMenu";
import PageLoader from "../components/PageLoader";
import "./appShell.css";

export default function MasterLayout() {
  const { user, loading, logout, has, error, retry } = useMasterAuth();
  const { brand } = useBranding();
  const navigate = useNavigate();
  if (loading)
    return (
      <div className="min-h-screen bg-[#080D18] text-slate-300 flex items-center justify-center font-mono text-xs tracking-widest uppercase">
        Loading platform console…
      </div>
    );
  if (error) return <SessionUnavailable message={error} onRetry={retry} />;
  if (!user) return <Navigate to="/master/login" replace />;
  return (
    <div className="app-shell flex bg-background text-foreground">
      <aside className="app-shell-sidebar w-16 lg:w-64 shrink-0 bg-[#0B1220] border-r border-slate-800 flex flex-col text-slate-300">
        <MasterBrand brand={brand} />
        <MasterNavigation has={has} scrollScope={`master:${user?.id || user?.role}`} />
        <MasterUserMenu user={user} brand={brand} onLogout={() => { logout(); navigate("/master/login"); }} />
      </aside>
      <main className="app-shell-main flex-1 min-w-0 min-h-0 flex flex-col overflow-hidden">
        <div className="app-shell-viewport flex-1 min-w-0 min-h-0"><Suspense fallback={<PageLoader label="Loading page…" />}><Outlet /></Suspense></div>
      </main>
    </div>
  );
}
